<div class="sub-tabs-container">
  <fsx-filing-sub-tab-item
    *ngFor="let tab of filingSubTabItems$ | async; let i = index"
    [tab]="tab"
    (filingSubTabClickedEvent)="filingSubTabClickedEventHandler($event)"
  >
  </fsx-filing-sub-tab-item>
</div>
